(function () {
  function init() {
    if (!window.L) return;

    var mapEl     = document.getElementById('js-stockist-map');
    var listItems = document.querySelectorAll('.js-store[data-lat]');
    if (!mapEl || !listItems.length) return;

    var map = L.map('js-stockist-map', { zoomControl: false });

    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
      attribution: '&copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
      maxZoom: 16
    }).addTo(map);

    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}', {
      maxZoom: 16
    }).addTo(map);

    L.control.zoom({ position: 'bottomright' }).addTo(map);

    var dotIcon = L.divIcon({
      className: '',
      html: '<div class="js-map-dot"></div>',
      iconSize: [10, 10],
      iconAnchor: [5, 5],
      popupAnchor: [0, -8]
    });

    var latLngs = [];
    var entries = [];   // 絞り込み連動用に marker とブロックを持っておく

    listItems.forEach(function (item) {
      var lat  = parseFloat(item.dataset.lat);
      var lng  = parseFloat(item.dataset.lng);
      var name = item.dataset.name || '';
      var url  = item.dataset.url  || '';
      if (!lat || !lng) return;

      var popup =
        '<div class="js-map-popup">' +
        '<strong>' + name.toUpperCase() + '</strong>' +
        (url ? '<a href="' + url + '" target="_blank" rel="noopener">VISIT STORE ↗</a>' : '') +
        '</div>';

      var marker = L.marker([lat, lng], { icon: dotIcon })
        .bindPopup(popup, { closeButton: false, className: 'js-leaflet-popup' })
        .addTo(map);

      var nameLink = item.querySelector('.js-store__name');

      marker.on('click', function () {
        listItems.forEach(function (li) { li.classList.remove('is-active'); });
        item.classList.add('is-active');
      });

      if (nameLink) {
        nameLink.addEventListener('click', function (e) {
          if (!item.classList.contains('is-active')) {
            e.preventDefault();
            map.setView([lat, lng], 13);
            marker.openPopup();
            listItems.forEach(function (li) { li.classList.remove('is-active'); });
            item.classList.add('is-active');
          }
        });
      }

      latLngs.push([lat, lng]);

      var region = item.closest('.js-region');
      entries.push({
        marker: marker,
        latlng: [lat, lng],
        block: region ? region.dataset.block : ''
      });
    });

    function fitTo(points) {
      if (points.length === 1) {
        map.setView(points[0], 13);
      } else if (points.length > 1) {
        map.fitBounds(points, { padding: [24, 24] });
      }
    }

    fitTo(latLngs);

    // 絞り込みに合わせてピンを出し入れし、表示範囲も追従させる
    function applyFilter(block) {
      var shown = [];
      entries.forEach(function (e) {
        var visible = (block === 'ALL' || e.block === block);
        if (visible) {
          if (!map.hasLayer(e.marker)) e.marker.addTo(map);
          shown.push(e.latlng);
        } else if (map.hasLayer(e.marker)) {
          map.removeLayer(e.marker);
        }
      });
      map.closePopup();
      fitTo(shown.length ? shown : latLngs);
    }

    var sel = document.getElementById('js-filter-select');
    if (sel) {
      sel.addEventListener('change', function () { applyFilter(sel.value); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
